import { Link } from "react-router-dom";
import { Menu, Store, Lock } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "../ui/sheet";
import { Logo } from "./Logo";

const links = [
  { to: "/", label: "Shop", icon: Store, id: "nav-shop" },
  { to: "/admin", label: "Admin", icon: Lock, id: "nav-admin" },
];

export const Header = () => (
  <header data-testid="store-header" className="sticky top-0 z-50 border-b border-white/[0.06] bg-[#121026]/80 backdrop-blur-xl">
    <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4">
      <Link to="/" data-testid="header-home-link"><Logo /></Link>
      <Sheet>
        <SheetTrigger asChild>
          <button data-testid="header-menu-button" aria-label="Menu" className="rounded-xl p-2 text-zinc-300 transition-colors hover:bg-white/5 hover:text-white">
            <Menu className="h-6 w-6" strokeWidth={1.5} />
          </button>
        </SheetTrigger>
        <SheetContent className="border-l border-white/10 bg-[#141129] text-white">
          <SheetTitle className="sr-only">Menu</SheetTitle>
          <nav className="mt-12 flex flex-col gap-2">
            {links.map(({ to, label, icon: Icon, id }) => (
              <Link key={to} to={to} data-testid={id} className="flex items-center gap-3 rounded-xl px-4 py-3 font-display text-lg transition-colors hover:bg-white/5">
                <Icon className="h-5 w-5 text-violet-400" /> {label}
              </Link>
            ))}
          </nav>
        </SheetContent>
      </Sheet>
    </div>
  </header>
);
